/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { FSFBImageType } from './fsfbimage-type';

export class ImageProto {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ImageProto {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsImageProto(bb: flatbuffers.ByteBuffer, obj?: ImageProto): ImageProto {
    return (obj || new ImageProto()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsImageProto(bb: flatbuffers.ByteBuffer, obj?: ImageProto): ImageProto {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ImageProto()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  width(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  height(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  asset(): string | null;
  asset(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  asset(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  uploadId(): string | null;
  uploadId(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  uploadId(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  thumb(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  thumbLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  thumbArray(): Int8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset
      ? new Int8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  ninePatch(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  ninePatchLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  ninePatchArray(): Int8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset
      ? new Int8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  density(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  dominantColor(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  imageType(): FSFBImageType {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : FSFBImageType.STANDARD;
  }

  static startImageProto(builder: flatbuffers.Builder) {
    builder.startObject(9);
  }

  static addWidth(builder: flatbuffers.Builder, width: number) {
    builder.addFieldInt32(0, width, 0);
  }

  static addHeight(builder: flatbuffers.Builder, height: number) {
    builder.addFieldInt32(1, height, 0);
  }

  static addAsset(builder: flatbuffers.Builder, assetOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, assetOffset, 0);
  }

  static addUploadId(builder: flatbuffers.Builder, uploadIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, uploadIdOffset, 0);
  }

  static addThumb(builder: flatbuffers.Builder, thumbOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, thumbOffset, 0);
  }

  static createThumbVector(
    builder: flatbuffers.Builder,
    data: number[] | Int8Array,
  ): flatbuffers.Offset;
  /**
   * @deprecated This Uint8Array overload will be removed in the future.
   */
  static createThumbVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset;
  static createThumbVector(
    builder: flatbuffers.Builder,
    data: number[] | Int8Array | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startThumbVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addNinePatch(builder: flatbuffers.Builder, ninePatchOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, ninePatchOffset, 0);
  }

  static createNinePatchVector(
    builder: flatbuffers.Builder,
    data: number[] | Int8Array,
  ): flatbuffers.Offset;
  /**
   * @deprecated This Uint8Array overload will be removed in the future.
   */
  static createNinePatchVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset;
  static createNinePatchVector(
    builder: flatbuffers.Builder,
    data: number[] | Int8Array | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startNinePatchVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addDensity(builder: flatbuffers.Builder, density: number) {
    builder.addFieldInt32(6, density, 0);
  }

  static addDominantColor(builder: flatbuffers.Builder, dominantColor: number) {
    builder.addFieldInt32(7, dominantColor, 0);
  }

  static addImageType(builder: flatbuffers.Builder, imageType: FSFBImageType) {
    builder.addFieldInt8(8, imageType, FSFBImageType.STANDARD);
  }

  static endImageProto(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createImageProto(
    builder: flatbuffers.Builder,
    width: number,
    height: number,
    assetOffset: flatbuffers.Offset,
    uploadIdOffset: flatbuffers.Offset,
    thumbOffset: flatbuffers.Offset,
    ninePatchOffset: flatbuffers.Offset,
    density: number,
    dominantColor: number,
    imageType: FSFBImageType,
  ): flatbuffers.Offset {
    ImageProto.startImageProto(builder);
    ImageProto.addWidth(builder, width);
    ImageProto.addHeight(builder, height);
    ImageProto.addAsset(builder, assetOffset);
    ImageProto.addUploadId(builder, uploadIdOffset);
    ImageProto.addThumb(builder, thumbOffset);
    ImageProto.addNinePatch(builder, ninePatchOffset);
    ImageProto.addDensity(builder, density);
    ImageProto.addDominantColor(builder, dominantColor);
    ImageProto.addImageType(builder, imageType);
    return ImageProto.endImageProto(builder);
  }
}
